import { WorkStatusEnum } from "@altertec_gparn/lib";

export class WorkTaskDto {
  status: WorkStatusEnum;

  pendingWork: string;

  rotorLock?: boolean | null;
}
